import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
  string,
} from 'libs/form';

export const CODE_LENGTH = 6;

export interface SignOrderFormType {
  otpCode: string;
}

export const getSchema = (): ObjectSchema<SignOrderFormType> =>
  object({
    otpCode: string().min(CODE_LENGTH).required(),
  });

export const { Field, Form, useFormContext, useField, Submit } =
  TypedForm<SignOrderFormType>();

export type SignOrderFormErrors = FormErrorsBase<SignOrderFormType>;
